import script from "./invoice-uninvoiced-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-uninvoiced-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__